<template>
	<div>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" :params="params" @action="processPurchase"></ModalConfirm>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :msgTwo="msgSuccessTwo" :link="link"></ModalSuccess>
		<ModalFailed ref="modalFailed" :msg="msgFailed"></ModalFailed>
		<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
			<v-row v-if="step1">
				<v-col cols="12" sm="6" md="6" xl="4">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="12" class="px-5 pt-5">
								<v-row class="align-center">
									<v-col cols="12" sm="12" md="6" xl="7"><div class="font-size-14 cl-primary">Input Kode Stockist</div></v-col>
									<v-col cols="12" sm="12" md="6" xl="5" class="text-right">
										<v-btn
											color="primary"
											outlined
											block
											class="text-capitalize"
											@click="gotoStockist()"
										><v-icon dense class="mr-1">mdi-account-details</v-icon>Lihat Data Stockist</v-btn>
									</v-col>
								</v-row>
								
								<div class="pt-3">
									<v-text-field label="Kode Stockist" color="primary" v-model="stockist_code" @keyup.enter="nextStep"></v-text-field>
								</div>
								<div class="d-flex justify-end">
									<v-btn large width="120" depressed color="primary" class="rounded-lg" :disabled="!stockist_code" :loading="btnLoading" @click="nextStep">
										<v-icon>mdi-arrow-right-bold-circle</v-icon>
										<span class="pl-2 text-capitalize">Lanjut</span>
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-scroll-x-reverse-transition>
		<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
			<div v-if="!step1">
				<v-row class="mb-3 justify-space-between">
					<v-col cols="12" sm="6" md="4" class="flex-stretch">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height">
							<div class="d-flex flex-row align-start">
								<v-icon large color="primary" class="px-2 mb-2">mdi-storefront</v-icon>
								<div class="d-flex flex-column pl-3">
									<span class="font-weight-bold font-size-13 mb-1 cl-primary">Info Stockist</span>
									<span class="cl-secondary font-size-11"><b>{{ dataStockist.member_network_code }}</b> ( {{ dataStockist.member_name }} )</span>
									<span class="cl-secondary font-size-9">{{ dataStockist.member_stockist_mobilephone }} <template v-if="dataStockist.member_city_name">&nbsp;&nbsp;|&nbsp;&nbsp; {{ dataStockist.member_city_name }}</template></span>
								</div>
							</div>
						</v-card>
					</v-col>

					<v-col cols="12" sm="6" md="4" class="flex-stretch">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height">
							<div class="d-flex flex-row align-start">
								<v-icon large color="info" class="px-2 mb-2">mdi-wallet-outline</v-icon>
								<div class="d-flex flex-column pl-3">
									<span class="font-weight-bold font-size-13 mb-1 blue--text">Total Saldo Belanja</span>
									<span class="cl-secondary font-size-14 font-weight-500">{{ dataEwallet.ewallet_product_balance_formatted }}</span>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<v-row class="mt-3 ml-0 body-transaction-product body-transaction-product-sm">
					<v-col cols="12" sm="4" md="3" xl="2" class="pl-0 pt-0 col-md-20 d-flex flex-stretch" v-for="product in listProductMitra" :key="product.product_id">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow h-100">
							<v-img contain height="165px" class="rounded-lg" :src="product.product_image" v-if="product.product_image"></v-img>
							<v-img height="165px" class="rounded-lg" src="/assets/image/user-pict.jpg" v-if="!product.product_image"></v-img>
							<div class="pt-3">
								<div class="font-size-11 product-name">{{ product.product_name }}</div>
								<div class="font-size-14 cl-primary">{{ product.product_member_price | toRupiah }}</div>
								<div class="pt-1 font-size-11 cl-grey">Stok
									<span v-if="product.product_qty > 0"> : {{ product.product_qty | toNumber }}</span>
									<span class="red--text text--darken-3 font-weight-500" v-else>Habis</span>
								</div>
							</div>
							<div class="checked-input mt-2 mb-1" :class="(!product.checked) ? 'grey lighten-4' : 'orange lighten-5'">
								<v-col cols="12" class="pa-0 d-flex">
									<v-checkbox hide-details class="mt-0 pt-0 mr-0" :class="{'green--text' : product.checked}" label="Beli Produk" on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" :disabled="product.product_qty == 0" v-model="product.checked" @click="checkBuy(product, product.product_id)"></v-checkbox>
								</v-col>
							</div>
							<v-row class="pt-2 justify-space-between align-center">
								<v-col cols="2" sm="3" md="3" xl="3" class="">
									<v-btn elevation="0" small :disabled="!product.checked" @click="decQty(product)" class="px-0" style="min-width: 33px;">
										<v-icon color="error">mdi-minus-circle-outline</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="8" sm="6" md="6" xl="6" class="px-0">
									<div class="">
										<v-text-field dense hide-details="auto" v-model="product.quantity" :disabled="!product.checked" @keypress="onlyNumber" @keyup="addTotal(product)" @paste.prevent :rules="rules.inputQty"></v-text-field>
									</div>
								</v-col>
								<v-col cols="2" sm="3" md="3" xl="3" class="">
									<v-btn elevation="0" small :disabled="!product.checked" @click="addQty(product)" class="px-0 flex-shrink-0" style="min-width: 33px;">
										<v-icon color="primary">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<div class="footer-transaction-product rounded-lg">
					<div class="d-flex flex-wrap">
						<v-col cols="12" sm="6" class="pa-0">
							<div class="font-size-11 product-name"><b>{{ firstData.length }}</b> Item produk dipilih</div>
							<div class="font-size-14 cl-primary">{{ sumTotal | toRupiah }}</div>
						</v-col>
						<v-col cols="12" sm="6" class="d-none d-md-block pb-0 px-0 pa-sm-0 text-right my-auto">
							<v-btn large width="120" depressed class="rounded-lg mr-2" @click="backStep">
								<v-icon>mdi-arrow-left</v-icon>
								<span class="pl-2">Kembali</span>
							</v-btn>
							<v-btn large width="120" depressed color="primary" class="rounded-lg" :disabled="firstData.length == 0" @click="showConfirm">
								<v-icon>mdi-cart-arrow-right</v-icon>
								<span class="pl-2">Beli</span>
							</v-btn>
						</v-col>

						<v-col cols="12" sm="6" class="d-flex d-md-none align-center justify-space-between pb-0 px-0 pa-sm-0 text-right my-auto">
							<v-btn large width="120" depressed class="d-flex flex-grow-1 flex-shrink-1 mx-1 rounded-lg mr-2" @click="backStep">
								<v-icon>mdi-arrow-left</v-icon>
								<span class="pl-2">Kembali</span>
							</v-btn>
							<v-btn large width="120" depressed color="primary" class="d-flex flex-grow-1 flex-shrink-1 mx-1 rounded-lg" :disabled="firstData.length == 0" @click="showConfirm">
								<v-icon>mdi-cart-arrow-right</v-icon>
								<span class="pl-2">Beli</span>
							</v-btn>
						</v-col>
					</div>
				</div>
			</div>
		</v-scroll-x-transition>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from '@/components/modals/vo/ModalConfirm';
import ModalSuccess from '@/components/modals/vo/ModalSuccess';
import ModalFailed from '@/components/modals/vo/ModalFailed';

export default {
	components: {
		ModalConfirm, ModalSuccess, ModalFailed
	},
	data() {
		return {
			step1: true,
			btnLoading: false,
			stockist_code: '',
			dataEwallet: null,
			dataStockist: null,
			firstData: [],
			params: {},
			msgConfirm: "Yakin ingin memproses pembelian?",
			msgSuccess: "Transaksi anda berhasil disimpan. Stockist kami akan segera memproses pesanan Anda. Silakan",
			msgSuccessTwo: "untuk melihat detail belanja produk Anda. Terima kasih.",
			msgFailed: "Mohon Maaf transaksi Anda Gagal. Silakan ulangi kembali untuk melakukan pembelian Produk Anda",
			link: "lap-pembelian-produk",
			rules: {
				inputQty: [
					v => parseFloat(v) < 1001 || 'Jumlah pembelian maksimal 1000',
				],
			}
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('product', ['listProductMitra']),

		sumTotal() {
			let total = 0
			this.firstData.forEach((el) => {
				total += parseInt(el.total)
			})
			return total
		}
	},
	methods: {
		...mapActions('product', ['getProductMitra']),
		...mapActions('transactionProduct', ['addTransactionProductMitra']),

		gotoStockist() {
			let routeData = this.$router.resolve({name: 'list-stockist'});
			window.open(routeData.href, '_blank');
		},

		getData() {
			this.getProductMitra({network_code: this.stockist_code}).then((response) => {
				this.dataEwallet = response.data_ewallet
				this.dataStockist = response.data_stockist
			})
		},
		nextStep() {
			this.btnLoading = true
			this.getProductMitra({network_code: this.stockist_code}).then((response) => {
				this.dataEwallet = response.data_ewallet
				this.dataStockist = response.data_stockist
				this.step1 = false
				this.btnLoading = false
			}).catch(() => {
				this.btnLoading = false
				this.step1 = true
			})
		},
		backStep() {
			this.stockist_code = ''
			this.dataEwallet = null
			this.dataStockist = null
			this.step1 = true
		},
		checkBuy(product, id) {
			if (product.checked == true) {
				this.firstData.push(product)
			} else {
				this.firstData = this.firstData.filter(function(item) {
					return item.product_id !== id
				})
			}
		},
		addQty(product) {
			if (product.quantity >= 0) {
				if (product.quantity <= (product.product_qty -1)) {
					product.quantity++
					product.total = product.quantity * product.product_member_price
				}
			}
		},
		decQty(product) {
			if (product.quantity > 1) {
				product.quantity--
				product.total = product.quantity * product.product_member_price
			}
		},
		addTotal(product) {
			if (parseInt(product.quantity) > parseInt(product.product_qty)) {
				product.quantity = product.product_qty
			} else if (product.quantity <= 0) {
				product.quantity = 1
			}
			product.total = product.quantity * product.product_member_price
		},
		processTransaction() {
			let data = this.firstData
			let product_id = []
			let product_qty = []
			data.forEach((res) => {
				let id = res.product_id;
				let qty = res.quantity;
				product_id.push(id);
				product_qty.push(qty);
			})
			let product_member_network_code = this.stockist_code
			this.params = {product_id,product_qty,product_member_network_code}
		},
		showConfirm() {
			this.processTransaction()
			this.$refs.modalConfirm.modalShow()
		},
		processPurchase() {
			this.$refs.modalConfirm.loadingButton()
			this.addTransactionProductMitra(this.params).then(() => {
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.$refs.modalSuccess.modalShow()
				this.firstData = []
				this.params = {}
				this.getData()
			}).catch(() => {
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.$refs.modalFailed.modalShow()
			})
		}
	},
	created(){
	},
};
</script>

<style lang="scss">
.footer-transaction-product {
	position: sticky;
	border: 1px solid #ddd;
	box-shadow: 0 0.46875rem 2.1875rem rgb(4 9 20 / 1%), 0 0.9375rem 1.40625rem rgb(4 9 20 / 1%), 0 0.25rem 0.53125rem rgb(4 9 20 / 4%), 0 0.125rem 0.1875rem rgb(4 9 20 / 1%) !important;
}	
</style>
